import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppState } from './../../../app.service';
import { AppVars } from './../../../app.vars';

// TODO: Define an InboundRequest Interface
// TODO: Define the InboundRequest Status enum
// 0: new, 1: on-hold, 2: accepted, 3: rejected 4: cancelled
@Injectable()
export class InboxDataService {
  constructor(private ngDb: AngularFireDatabase, private _as: AppState) {}

  getInboundRequests(): Observable<any[]> {
    const inboundRequestsPath = this.getInboundRequestsPath();
    return this.ngDb
      .list(inboundRequestsPath, (ref) => ref.orderByChild('statusId').startAt(0).endAt(1))
      .snapshotChanges()
      .pipe(map((requests: any[]) => requests.map((req) => ({ id: req.key, ...req.payload.val() }))));
  }

  getAcceptedInboundRequests(): Observable<any[]> {
    const inboundRequestsPath = this.getInboundRequestsPath();
    return this.ngDb
      .list(inboundRequestsPath, (ref) => ref.orderByChild('statusId').equalTo(2).limitToLast(50))
      .snapshotChanges()
      .pipe(
        map((requests: any[]) => requests.map((req) => ({ id: req.key, ...req.payload.val() }))),
        // sort by acceptedOn date
        map((requests) =>
          requests.sort((a, b) => {
            const dateA = new Date(a.acceptedOn).getTime();
            const dateB = new Date(b.acceptedOn).getTime();
            return dateB - dateA; // Sort in descending order
          })
        )
      );
  }

  getRejectedInboundRequests(): Observable<any[]> {
    const inboundRequestsPath = this.getInboundRequestsPath();
    return this.ngDb
      .list(inboundRequestsPath, (ref) => ref.orderByChild('statusId').startAt(3).limitToLast(50))
      .snapshotChanges()
      .pipe(
        map((requests: any[]) => requests.map((req) => ({ id: req.key, ...req.payload.val() }))),
        // sort by rejectedOn date
        map((requests) =>
          requests.sort((a, b) => {
            const dateA = new Date(a.rejectedOn).getTime();
            const dateB = new Date(b.rejectedOn).getTime();
            return dateB - dateA; // Sort in descending order
          })
        )
      );
  }

  getNewInboundRequestCount(): Observable<number> {
    const inboundRequestsPath = this.getInboundRequestsPath();
    return this.ngDb
      .list(inboundRequestsPath, (ref) => ref.orderByChild('statusId').endBefore(2))
      .valueChanges()
      .pipe(map((items) => items.length));
  }

  updateInboundRequest(req: any): Promise<any> {
    const path = `${this.getInboundRequestsPath()}/${req.id}`;
    return this.ngDb.object(path).update(req);
  }

  acceptInboundRequest(id: string): Promise<any> {
    const updateObj = {
      id: id,
      status: 'accepted',
      statusId: 2,
      acceptedOn: new Date().toISOString(),
    };
    return this.updateInboundRequest(updateObj);
  }

  rejectInboundRequest(id: string): Promise<any> {
    const updateObj = {
      id: id,
      status: 'rejected',
      statusId: 3,
      rejectedOn: new Date().toISOString(),
    };
    return this.updateInboundRequest(updateObj);
  }

  holdInboundRequest(id: string): Promise<any> {
    const updateObj = {
      id: id,
      status: 'on-hold',
      statusId: 1,
      onHoldSince: new Date().toISOString(),
    };
    return this.updateInboundRequest(updateObj);
  }

  private getInboundRequestsPath(): string {
    return `provider-org-${this._as.get(AppVars.ORG_CODE)}/inbound-requests`;
  }
}
